import { useState } from "react";
import { Link } from "react-router-dom"; // เพิ่ม import Link
import './header.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleDropdown1 = () => {
    setIsDropdownOpen1((prev) => !prev);
  };

  const toggleDropdown2 = () => {
    setIsDropdownOpen2((prev) => !prev);
  };

  return (
    <div className="container-fluid position-relative d-flex align-items-center justify-content-center">
      <nav id="navmenu" className={`navmenu ${isMenuOpen ? "active" : ""}`}>
        <ul>
          <li><Link to="/home" onClick={() => setIsMenuOpen(false)}>หน้าแรก</Link></li>
          <li className={`dropdown ${isDropdownOpen1 ? "open" : ""}`}>
            <a href="#" onClick={toggleDropdown1}>
              <span>รู้จักสหกรณ์</span>
              <i className={`bi bi-chevron-down toggle-dropdown ${isDropdownOpen1 ? "rotate" : ""}`}></i>
            </a>
            <ul className={`submenu ${isDropdownOpen1 ? "show" : ""}`}>
              <li><Link to="/purpose">วัตถุประสงค์</Link></li>
              <li><Link to="/vision">วิสัยทัศน์และพันธกิจ</Link></li>
              <li><Link to="/ethics">จรรยาบรรณ/จริยธรรม</Link></li>
              <li><Link to="/performance">ผลการดำเนินการ</Link></li>
              <li><Link to="/board">คณะกรรมการ</Link></li>
              <li><Link to="/ourteam">ทีมงานสหกรณ์</Link></li>
            </ul>
          </li>
          <li className={`dropdown ${isDropdownOpen2 ? "open" : ""}`}>
            <a href="#" onClick={toggleDropdown2}>
              <span>บริการของเรา</span>
              <i className={`bi bi-chevron-down toggle-dropdown ${isDropdownOpen2 ? "rotate" : ""}`}></i>
            </a>
            <ul className={`submenu ${isDropdownOpen2 ? "show" : ""}`}>
              <li><Link to="/depositservice">บริการด้านเงินฝาก</Link></li>
              <li><Link to="/shareservice">บริการด้านหุ้น</Link></li>
              <li><Link to="/personalloanads/all">บริการด้านสินเชื่อ</Link></li>
              <li><Link to="/manual">คู่มือสมาชิก</Link></li>
              <li><Link to="/giftvoucher">บัตรกำนัล</Link></li>
              <li><Link to="/bank">ช่องทางการโอนเงินเข้าบัญชี</Link></li>
            </ul>
          </li>
          <li><Link to="/anoucement" onClick={() => setIsMenuOpen(false)}>ประกาศ</Link></li>
          <li><Link to="/downloadform" onClick={() => setIsMenuOpen(false)}>ดาวน์โหลดแบบฟอร์ม</Link></li>
          <li><Link to="/register" onClick={() => setIsMenuOpen(false)}>สมัครสมาชิก</Link></li>
          <li><Link to="/activity" onClick={() => setIsMenuOpen(false)}>กิจกรรมสหกรณ์</Link></li>
          <li><Link to="/advertise" onClick={() => setIsMenuOpen(false)}>ข่าวประชาสัมพันธ์</Link></li>

          {/* ปุ่มเข้าสู่ระบบสมาชิก */}
          <li className="nav-button-item">
            <a 
              href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-member-login"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="btn-text-main">เข้าสู่ระบบสมาชิก</span>
            </a>
          </li>
        </ul>
      </nav>

      <i
        className={`mobile-nav-toggle d-xl-none bi ${isMenuOpen ? "bi-x" : "bi-list"}`}
        onClick={toggleMenu}
      ></i>
    </div>
  );
};

export default Navbar;